<template>
  <li>
    <button
      class="text-center bg-blue-300 block w-full p-3 border-t border-gray-200 hover:bg-blue-300 focus:outline-none"
      @click="selectTab(tabindex)"
    >
      {{ title }}
    </button>
  </li>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "tab-menu",
  props: {
    title: String,
    tabindex: Number,
    tabactive: Boolean
  },
  methods: {
    ...mapMutations(["setCurrentTab"]),
    selectTab(tabIndex) {
      if (this.tabactive) {
        this.setCurrentTab({ index: tabIndex, clean: true });
      }
    }
  }
};
</script>
